import {
  FaCashRegister,
  FaMoneyBill,
  FaUserCog,
  FaUserFriends,
  FaCalendarCheck,
  FaTable,
  FaRegMoneyBillAlt,
  FaSatelliteDish,
} from 'react-icons/fa';
import { MdCastConnected, MdLocalLibrary, MdSchool } from 'react-icons/md';
import CommuteIcon from '@material-ui/icons/Commute';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';

export const getDashboardCardArray = (t) => {
  return [
    {
      title: t('headings:admin'),
      shortTitle: t('headings:admin'),
      icon: FaUserCog,
      description: t('messages:lms_Description'),
      redirectUrl: '/app/notification',
      backgroundColor: 'rgba(227, 245, 241, 1)',
      rgbaColor: {
        r: 3,
        g: 206,
        b: 153,
        a: 1,
      },
    },
    {
      title: t('headings:payroll_mgt'),
      shortTitle: t('headings:payroll_mgt'),
      description: t('messages:feePayment_Description'),
      icon: FaCashRegister,
      redirectUrl: '/app/setup/master/department',
      backgroundColor: 'rgba(238, 238, 255, 1)',
      rgbaColor: {
        r: 122,
        g: 121,
        b: 252,
        a: 1,
      },
    },
    {
      title: t('headings:event_mgt'),
      shortTitle: t('headings:event_mgt'),
      description: t('messages:event_Description'),
      backgroundColor: 'rgba(251, 240, 200, 1)',
      icon: FaCalendarCheck,
      redirectUrl: '/app/events',
      rgbaColor: {
        r: 248,
        g: 211,
        b: 94,
        a: 1,
      },
    },
    {
      title: t('headings:time_table_mgt'),
      shortTitle: t('headings:time_table_mgt'),
      description: t('messages:time_table_Description'),
      backgroundColor: 'rgba(254, 222, 197, 1)',
      icon: FaTable,
      //   iconType: 'mdi',
      redirectUrl: '/app/tt',
      rgbaColor: {
        r: 254,
        g: 133,
        b: 42,
        a: 1,
      },
    },
    // {
    //   title: t('headings:fee_mgt'),
    //   shortTitle: t('headings:short_fee_mgt'),
    //   description: t('messages:feePayment_Description'),
    //   backgroundColor: 'rgba(251, 232, 241, 1)',
    //   icon: FaRegMoneyBillAlt,
    //   redirectUrl: '',
    //   rgbaColor: {
    //     r: 234,
    //     g: 145,
    //     b: 188,
    //     a: 1,
    //   },
    // },

    {
      title: t('headings:communication_channels'),
      shortTitle: t('headings:communication_channels'),
      description: t('messages:etl_Description'),
      icon: FaSatelliteDish,
      backgroundColor: 'rgba(235, 244, 252, 1)',
      redirectUrl: `/app/notification`,
      rgbaColor: {
        r: 109,
        g: 176,
        b: 235,
        a: 1,
      },
    },
    {
      title: t('headings:role_mgt'),
      shortTitle: t('headings:role_mgt'),
      description: t('messages:etl_Description'),
      icon: FaUserFriends,
      redirectUrl: `/app/assignRoles`,
      backgroundColor: 'rgba(251, 230, 228, 1)',
      rgbaColor: {
        r: 226,
        g: 87,
        b: 76,
        a: 1,
      },
    },
    {
      title: t('headings:academics_planner'),
      shortTitle: t('headings:academics_planner'),
      description: 'Academics planner description here',
      icon: MdSchool,
      redirectUrl: `/app/academics-planner`,
      backgroundColor: 'rgba(54, 34, 11, 1)',
      rgbaColor: {
        r: 214,
        g: 181,
        b: 117,
        a: 1,
      },
    },
    {
      title: t('headings:Admin Management'),
      shortTitle: t('headings:Exam Management'),
      description: 'Admin Management description here',
      icon: FaUserCog,
      redirectUrl: '/app/admin-management',
      backgroundColor: 'rgba(227, 245, 241, 1)',
      rgbaColor: {
        r: 3,
        g: 206,
        b: 153,
        a: 1,
      },
    },
  ];
};
